<script lang="ts" setup>
import { DialogTitle } from "@headlessui/vue";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";

defineProps<{
  title?: string;
  content?: string;
}>();
</script>

<template>
  <div class="sm:flex sm:items-start">
    <div
      class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10"
    >
      <ExclamationTriangleIcon aria-hidden="true" class="size-6 text-red-600" />
    </div>
    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
      <DialogTitle as="h3" class="text-base font-semibold text-gray-900"
        >{{ title ?? "Weet je het zeker?" }}
      </DialogTitle>
      <div class="mt-2">
        <p class="text-sm text-gray-500">
          {{ content ?? "Dit kan niet ongedaan gemaakt worden." }}
        </p>
      </div>
    </div>
  </div>
</template>
